import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { 
  PainelControleRiscoRequest,
  PainelControleRiscoResponse,
  PainelControleRiscoToalizadoresRequest,
  PainelControleRiscoTotalizadoresResponse
} from 'src/app/@shared/models/painel-risco.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filters = (param: PainelControleRiscoRequest | PainelControleRiscoToalizadoresRequest) => {
  const filter = Object.entries(param).filter(([k, v]) => v && (k !== 'paging'));
  return new URLSearchParams(filter);
}

@Injectable({
  providedIn: 'root'
})
export class PainelControleRiscoService {

  constructor(private http: HttpClient) { }
  
  listarPainelControleRisco(obj: PainelControleRiscoToalizadoresRequest): Observable<PainelControleRiscoResponse[]> {
    return this.http.get<PainelControleRiscoResponse[]>(
      `PainelControleRisco/Resultado?${filters(obj)}`,
      httpOptions
    );
  }

  exportaExcel(obj: PainelControleRiscoToalizadoresRequest): Observable<any> {
    return this.http.get<any>(
      `PainelControleRisco/Resultado/ExportarExcel?${filters(obj)}`,
      httpOptions
    );
  }

  consultarTotalizadores(obj: PainelControleRiscoRequest): Observable<PainelControleRiscoTotalizadoresResponse[]> {
    return this.http.get<PainelControleRiscoTotalizadoresResponse[]>(
      `PainelControleRisco/SelecionarTotalizadores?${filters(obj)}`,
      httpOptions
    );
  }
}
